// Internal feature flag utility
const feature = (enabled = false, required = false) => ({ enabled, required });

// Common presets
const ENABLED = feature(true, false);
const ENABLED_REQUIRED = feature(true, true);
const DISABLED = feature(false, false);

// Default feature configuration
const defaultFeatures = {
  title: ENABLED_REQUIRED,
  title_url: ENABLED_REQUIRED,
  desc: ENABLED_REQUIRED,
  tags: ENABLED_REQUIRED,
  team: ENABLED_REQUIRED,
  agency: ENABLED_REQUIRED,
  ctype: ENABLED_REQUIRED,
  lang: ENABLED,
  category: ENABLED_REQUIRED,
  subcategory: ENABLED,
  production_type: ENABLED_REQUIRED,
  expiry: ENABLED,
  is_short: ENABLED,
  is_campaign: ENABLED,
  landscapeThumb: ENABLED,
  socialThumb: ENABLED,
  posterThumb: ENABLED,
  portraitThumb: ENABLED,
  podcastThumb: ENABLED,
  premiereThumb: ENABLED,
  premiereVThumb: ENABLED,
  youtube_id: ENABLED,
  parentid: ENABLED,
  creditors: ENABLED,
  contributors: ENABLED,
  denmark: ENABLED,
  social_publish_destination: ENABLED,
  social_publish_page: ENABLED,
  campaign_id: ENABLED,
};

// Utility to override defaults
const withOverrides = (
  overrides: Partial<typeof defaultFeatures>
): typeof defaultFeatures => ({
  ...defaultFeatures,
  ...overrides,
});

// Media type-specific feature maps
const mediaFeatureMap = {
  video: withOverrides({
    title_url: ENABLED_REQUIRED,
    agency: ENABLED_REQUIRED,
    ctype: ENABLED_REQUIRED,
    landscapeThumb: ENABLED_REQUIRED,
  }),
  audio: withOverrides({
    agency: ENABLED_REQUIRED,
    title_url: ENABLED_REQUIRED,
  }),
  drive: withOverrides({
    title_url: DISABLED,
    agency: ENABLED_REQUIRED,
    youtube_id: DISABLED,
    denmark: DISABLED,
  }),
  campaign: withOverrides({
    agency: ENABLED_REQUIRED,
  }),
  shorts: withOverrides({
    title_url: ENABLED_REQUIRED,
    agency: ENABLED_REQUIRED,
    // is_short: DISABLED,
  }),
  slates: withOverrides({
    title_url: DISABLED,
    agency: ENABLED_REQUIRED,
    // socialThumb: DISABLED,
    // posterThumb: DISABLED,
    // portraitThumb: DISABLED,
    youtube_id: DISABLED,
    parentid: DISABLED,
    denmark: DISABLED,
    social_publish_destination: DISABLED,
    social_publish_page: DISABLED,
  }),
  premiere: withOverrides({
    social_publish_destination: DISABLED,
    social_publish_page: DISABLED,
  }),
} as const;

export type MediaDetailFeatureMapKey = keyof typeof mediaFeatureMap;
export type MediaDetailFeatures = typeof defaultFeatures;

// Public React hook to access media features
export const MediaDetailConfig = (
  type: MediaDetailFeatureMapKey
): MediaDetailFeatures => {
  return mediaFeatureMap[type] ?? defaultFeatures;
};
